import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import {
	API_RESOURCES,
	createApiUpdateAction,
	HTTP_REQUEST_METHODS,
	createApiReadAction,
	createApiCreateAction,
	createApiDeleteAction
} from '../../util/api';

export function getAllEngagementManageAccounts(engagementId, actionProps, queryParameters) {
	const defaultQueryString = {
		orderBy: 'AccountName',
		IncludeAssertions: true,
		IncludePspIndexes: true,
		IncludeRelatedRisks: true,
		IncludeHelix: true,
		IncludeEntities: true,
		IncludeRelatedDocuments: true
	};

	return createApiReadAction(
		types.GET_MANAGE_ACCOUNTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ACCOUNTS]: null
		},
		queryParameters || defaultQueryString,
		{...actionProps, resolve: true}
	);
}

export const getManageAccountById = (engagementId, accountId, queryParameters, actionProps) => {
	const defaultQueryParams = {
		includeAssertions: true,
		includePspIndexes: true,
		includeRelatedRisks: true,
		includeHelix: true,
		includeEntities: true,
		includeRelatedDocuments: true
	};

	const url =
		env.getBaseURL(serviceURL, engagementId) +
		`Accounts/${accountId}?` +
		Utility.getAccountParams(queryParameters || defaultQueryParams);

	return {
		type: types.GET_MANAGE_ACCOUNT_BY_ID,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		accountId,
		resolve: true
	};
};

export function deleteManageAccount(engagementId, accountId) {
	let url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Accounts' + '/' + accountId;

	return {
		type: types.DELETE_MANAGE_ACCOUNT,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		accountId
	};
}

export const createManageAccount = (engagementId, data, actionProps) => {
	const url = `${env.getBaseURL(serviceURL, engagementId)}Accounts`;
	return {
		type: types.CREATE_MANAGE_ACCOUNT,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		}
	};
};

export const updateManageAccount = (engagementId, accountId, data, actionProps) => {
	const action = createApiUpdateAction(
		types.UPDATE_MANAGE_ACCOUNT,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ACCOUNTS]: accountId
		},
		data,
		HTTP_REQUEST_METHODS.PUT,
		{...actionProps, accountId}
	);
	action.resolve = true;
	return action;
};

export function cleanManageAccount() {
	return {
		type: types.CLEAN_MANAGE_ACCOUNT
	};
}
